export default __webpack_public_path__ + "static/media/f2.bf066099.png";